import { differenceInHours } from 'date-fns'

export const inBrowser = !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
);


export const didDisplaySplashInfo = () => {
    var didShow = inBrowser ? window.sessionStorage.getItem("ace_did_show_splash_info") : true;
    return didShow;
}

export const shouldDisplaySplashInfo = () => {
    var didShow = inBrowser ? window.sessionStorage.getItem("ace_did_show_splash_info") : true;
    // try {
    //     var lastSplashDate =  inBrowser ? window.localStorage.getItem("ace_did_show_splash_info") : null;
    //     if(lastSplashDate) {
    //         lastSplashDate =  new Date(lastSplashDate)
    //         // console.log('test:',(!didShow && differenceInHours(lastSplashDate, new Date()) > 1), !didShow, differenceInHours(lastSplashDate, new Date()) > 1)
    //         return (!didShow && differenceInHours(lastSplashDate, new Date()) > 1) 
    //     }
    // } catch (err) {
    //     console.log("didDisplaySplashInfo Error:" , err);
    // }
    // console.log('didShow:',!didShow)
    return !didShow;
}

export const setDidDisplaySplashInfo = (value) => {
    inBrowser ? window.localStorage.setItem("ace_did_show_splash_info", new Date()) : null;
    return inBrowser ? window.sessionStorage.setItem("ace_did_show_splash_info", value) : null;
}
